<div class="markdown-html text-center">
	<div>{{'workflow.test.completed' | translate}}</div>
	<div class="centered" *ngIf="(workflowItemKey.property$ | async) as values">
		<table>
			<tbody>
				<tr>
					<td class="left-align">{{'workflow.test.tapping.cycle' | translate:{'num': 1} }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[0]?.taps | number:'1.0-3' }}</td>
				</tr>
				<tr>
					<td class="left-align">{{'workflow.test.tapping.cycle' | translate:{'num': 2} }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[1]?.taps | number:'1.0-3' }}</td>
				</tr>
				<tr>
					<td class="left-align">{{'workflow.test.tapping.cycle' | translate:{'num': 3} }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[2]?.taps | number:'1.0-3' }}</td>
				</tr>
				<tr>
					<td class="left-align">{{'workflow.test.tapping.cycle' | translate:{'num': 4} }}</td>
					<td class="center-align cell-padding">:</td>
					<td class="right-align cell-padding">{{ values[3]?.taps | number:'1.0-3' }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
